const set_link = {
  namespaced: true,
  state:{
    link_dialog_show:false,
    link_edit: {},
    link_fun: false, // 只显示功能其他的选项不显示
    contact_us_link: false
  },
  mutations:{
    set_link_dialog_show(state, val){
      state.link_dialog_show = val;
    },
    set_link_edit(state, val){
      state.link_edit = val;
    },
    set_link_fun(state, val){
      state.link_fun = val;
    },
    set_link_contact_us(state, val) {
      state.contact_us_link = val
    }
  },
  actions:{
  },
  getters:{
  }
};


export default set_link;



// WEBPACK FOOTER //
// ./src/vuex/modules/set_link.js